<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de acesso ao cuidado programado">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/atencao-basica/relatorio-acesso-cuidado-programado/List'

export default {
    components: {List},
}
</script>